import _ from 'lodash'
import queryString from 'query-string'

const ENV = {}
_.forEach(process.env, (val, key) => {
  ENV[key.replace('REACT_APP_', '')] = val
})

// if whitelisted param exists in querystring then use it to override the configs
// the querystring params are case-insensitive
const whitelist = ['API_URL', 'FETCH_INTERVAL', 'GRID_FLOW', 'TOTAL_NUMBERS', 'ORDER_CONFIRMED_DATE', 'STORE_CODE', 'FAKE_TICKET_NUMBERS']
const qs = queryString.parse(window.location.search, { arrayFormat: 'bracket'})
const params = _.reduce(qs, (res, value, key) => {
  let upperKey = _.toUpper(key)
  if (_.indexOf(whitelist, upperKey) !== -1) {
    res[upperKey] = value
  }
  return res
}, {})

const defaults = {
  API_URL: 'http://localhost:3000',
  FAKE_TICKET_NUMBERS: 0,
  FETCH_INTERVAL: 5 * 1000,
  MAXIMUM_ERRORS_RETRY: 100,
  GRID_FLOW: 'row',
  TOTAL_NUMBERS: 15, // used to determine the grid size, excludes latest ready number
  ORDER_CONFIRMED_DATE: null,
  ...ENV,
  ...params,
}

export default class Config {
  static get(key) {
    let value = defaults[key]
    switch (true) {
      case _.isInteger(value):      value = parseInt(value, 10); break
      case /true|on/.test(value):   value = true; break
      case /false|off/.test(value): value = false; break
      default: break
    }
    return value
  }
}



// WEBPACK FOOTER //
// ./src/configs/index.js